import styled from "styled-components";

const DiaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .diary_header {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 10px;
    .branch_details {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .spacerContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .flexdContainer {
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }
  .rowContainer {
    display: flex;
  }
  .horizontal_spacer {
    width: ${(props) => (props["print"] === true ? "10px" : "40px")};
  }
  .vertical_spacer {
    height: 10px;
    &.high {
      height: 20px;
    }
  }
  .vertical {
    /* min-height: 25px; */
    width: 100%;
    display: flex;
  }
  .centered {
    display: flex;
    justify-content: center;
  }
  .horizontal_item_container {
    display: flex;
  }
  .item_container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .item_container_auto {
    display: flex;
    flex-direction: column;
  }
  .section {
    width: fit-content;
    padding: 0 10px;
  }
  .borderedSection {
    width: fit-content;
    padding: 0 10px;
    border: 1px dashed;
    padding-bottom: 5px;
  }
  .statements {
    span {
      font-size: 0.8em;
    }
  }

  .horizontal_line {
    border-bottom: 1px solid #000000;
    margin: 0 10px;
    width: 80px;
    &.short {
      width: 40px;
    }
    &.long {
      width: 220px;
    }
    &.middle {
      width: 70px;
    }
    &.vertical {
      margin: 20px 0 5px 0;
    }
    &.flexed {
      flex: 1;
    }
  }
  h3.ant-typography {
    margin: 0;
  }
  .ant-divider-horizontal.ant-divider-with-text {
    margin: ${(props) => (props["print"] === true ? "5px 0px" : "16px 0px")};
  }
  span,
  td,
  th {
    font-size: ${(props) => (props["print"] === true ? "12px" : "initial")};
  }
  .ant-table.ant-table-small .ant-table-footer,
  .ant-table.ant-table-small .ant-table-tbody > tr > td,
  .ant-table.ant-table-small .ant-table-thead > tr > th,
  .ant-table.ant-table-small .ant-table-title,
  .ant-table.ant-table-small tfoot > tr > td,
  .ant-table.ant-table-small tfoot > tr > th {
    padding: 0 8px;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > thead
    > tr
    > th,
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > tbody
    > tr
    > td,
  .ant-table.ant-table-bordered > .ant-table-container {
    border-color: black !important;
    line-height: 1.2;
  }
  .ant-typography {
    color: #000000 !important;
  }
  .ant-typography.ant-typography-secondary {
    color: #000000bf !important;
  }
  .rest_day {
    .ant-table-cell:not(.signature) {
      background-color: #d9d9d9;
      color: #000000;
      &:hover {
        background-color: #d9d9d9 !important;
        color: #000000 !important;
      }
    }
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table {
    border-color: rgb(0 0 0);
  }
`;

export default DiaryWrapper;
